import { isInPastFromNow } from '@focuslee/shared';
import { Box } from '@mui/material';
import { hapticFeedback } from '@tma.js/sdk';
import dayjs from 'dayjs';
import { useNavigate } from 'react-router-dom';
import { ListCategory, ListGoal } from '../../client/types';
import { getTotalReward } from '../../helpers/goal';
import { goalsCompletedPath, goalsConfigurePath, goalsViewPath } from '../../navigation/paths';
import { QuestHeaderCompleted } from './goal/QuestHeaderCompleted';
import { QuestHeaderEmpty } from './goal/QuestHeaderEmpty';
import { QuestHeaderSlots } from './goal/QuestHeaderSlots';

export type QuestHeaderProps = {
    goals?: ListGoal[];
    goalCompletion?: string;
    categoryMap: Record<string, ListCategory>;
};

export const QuestHeader = ({ goals, goalCompletion, categoryMap }: QuestHeaderProps) => {
    const navigate = useNavigate();
    const activeGoals = goals?.filter(g => g.active) ?? [];
    const totalReward = getTotalReward(activeGoals);
    
    const handleCompletedGoalsClick = () => {
        hapticFeedback.impactOccurred.ifAvailable('light');
        navigate(goalsCompletedPath);
    };

    const handleEmptyGoalsClick = () => {
        hapticFeedback.impactOccurred.ifAvailable('light');
        navigate(goalsConfigurePath);
    };

    const handleViewGoalsClick = () => {
        hapticFeedback.impactOccurred.ifAvailable('light');
        navigate(goalsViewPath);
    };
    const content = goalCompletion && isInPastFromNow(dayjs(goalCompletion))
        ? <QuestHeaderCompleted totalReward={totalReward} onClick={handleCompletedGoalsClick} />
        : !goalCompletion || !goals || goals.length === 0
            ? <QuestHeaderEmpty onClick={handleEmptyGoalsClick} />
            : <QuestHeaderSlots goals={activeGoals} goalCompletion={goalCompletion} categoryMap={categoryMap} onClick={handleViewGoalsClick} />;

    return (
        <Box borderBottom="1px solid var(--tg-theme-section-bg-color)">
            {content}
        </Box>
    );
}